"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cloneArray = function (array, deep) {
    if (deep === void 0) { deep = true; }
    var clone = [];
    for (var i = 0; i < array.length; i++) {
        if (deep) {
            clone[i] = exports.immute(array[i]);
        }
        else {
            clone.push(array[i]);
        }
    }
    return clone;
};
exports.cloneObject = function (object, deep) {
    if (deep === void 0) { deep = true; }
    var clone = {};
    for (var key in object) {
        if (object.hasOwnProperty(key)) {
            if (deep) {
                clone[key] = exports.immute(object[key]);
            }
            else {
                clone[key] = object[key];
            }
        }
    }
    return clone;
};
exports.immute = function (arrayOrObject) {
    var type = Object.prototype.toString.call(arrayOrObject);
    if (type === "[object Object]") {
        return exports.cloneObject(arrayOrObject);
    }
    if (type === "[object Array]") {
        return exports.cloneArray(arrayOrObject);
    }
    return arrayOrObject;
};
//# sourceMappingURL=immute.js.map